/* ============================================================
   BloomUp — mobile sticky bar controller (v12, audited)

   v12 fix:
   - Price/MRP writes go through setMoneyText(), which also clears
     the "original price" data-attributes that client-side currency
     converter apps (BUCKS / mlveda-style) stamp on .money elements.
     Without this, after a variant switch the app kept converting
     from the stale cached amount instead of the new price.

   v11 fix:
   - openCartDrawer() opens via the theme's own cart trigger
     ([aria-controls="CartDrawer"]) FIRST; raw showModal() bypassed
     the drawer component's state and broke its close button.

   Kept from v10:
   - Footer paint + clearance mobile-only; quantity honours form=""
     inputs; 600ms double-tap guard.
   ============================================================ */
(function () {
  "use strict";

  var MOBILE = window.matchMedia("(max-width: 767px)");

  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  ready(function () {
    var bar = document.getElementById("bu-sticky-atc");
    if (!bar) return;

    document.body.classList.add("bu-sticky-open");

    /* ---------- paint the spacer with the footer's background ---------- */
    function visibleBg(el) {
      var cs = getComputedStyle(el);
      var hasColor = cs.backgroundColor && cs.backgroundColor !== "transparent" && cs.backgroundColor !== "rgba(0, 0, 0, 0)";
      var hasImage = cs.backgroundImage && cs.backgroundImage !== "none";
      if (hasColor || hasImage) {
        return { color: hasColor ? cs.backgroundColor : "", image: hasImage ? cs.backgroundImage : "" };
      }
      return null;
    }

    function footerBackground() {
      var roots = document.querySelectorAll(
        'footer, .shopify-section-group-footer-group, [id^="shopify-section"][id*="footer"], .hdt-section-footer'
      );
      for (var i = 0; i < roots.length; i++) {
        var queue = [roots[i]];
        var depth = 0;
        while (queue.length && depth < 60) {
          var el = queue.shift();
          depth++;
          var bg = visibleBg(el);
          if (bg) return bg;
          for (var j = 0; j < el.children.length && j < 6; j++) queue.push(el.children[j]);
        }
      }
      return null;
    }

    var painted = false;
    function paintSpacer() {
      if (!MOBILE.matches) {
        if (painted) {
          [document.body, document.documentElement].forEach(function (el) {
            el.style.removeProperty("background-color");
            el.style.removeProperty("background-image");
            el.style.removeProperty("background-repeat");
            el.style.removeProperty("background-size");
          });
          painted = false;
        }
        return;
      }
      var bg = footerBackground();
      if (!bg) return;
      [document.body, document.documentElement].forEach(function (el) {
        if (bg.color) el.style.backgroundColor = bg.color;
        if (bg.image) {
          el.style.backgroundImage = bg.image;
          el.style.backgroundRepeat = "no-repeat";
          el.style.backgroundSize = "100% 100%";
        }
      });
      painted = true;
    }

    /* ---------- position + single spacer for both fixed bars ---------- */
    function positionAboveToolbar() {
      var tb = document.querySelector(".hdt-toolbar");
      var h = 0;
      if (tb) {
        var r = tb.getBoundingClientRect();
        if (r.height > 0 && r.width > 0) h = Math.round(r.height);
      }
      bar.style.setProperty("--bu-toolbar-h", h + "px");
      document.body.style.setProperty("--bu-clearance", (h + bar.offsetHeight + 30) + "px");
      paintSpacer();
    }
    positionAboveToolbar();
    window.addEventListener("resize", positionAboveToolbar);
    if (MOBILE.addEventListener) MOBILE.addEventListener("change", positionAboveToolbar);
    setTimeout(positionAboveToolbar, 800);

    /* ---------- variant data ---------- */
    var variants = [];
    try {
      var el = bar.querySelector("[data-bu-variants]");
      if (el) variants = JSON.parse(el.textContent);
    } catch (e) { variants = []; }

    function mainForm() {
      return (
        document.querySelector(".hdt-main-product-wrap form.hdt-main-product-form") ||
        document.querySelector("form.hdt-main-product-form") ||
        (function () {
          var forms = document.querySelectorAll('form[action*="/cart/add"]');
          for (var i = 0; i < forms.length; i++) {
            var f = forms[i];
            if (f.id && f.id.indexOf("form-product-sticky") === 0) continue;
            if (bar.contains(f)) continue;
            if (f.querySelector('[name="id"]') || document.querySelector('[name="id"][form="' + f.id + '"]')) return f;
          }
          return null;
        })()
      );
    }

    function assocQuery(f, sel) {
      return f.querySelector(sel) || (f.id ? document.querySelector(sel + '[form="' + f.id + '"]') : null);
    }

    function idInput() {
      var f = mainForm();
      if (!f) return null;
      return assocQuery(f, '[name="id"]:not([disabled])') || assocQuery(f, '[name="id"]');
    }

    function currentVariantId() {
      var input = idInput();
      if (input && input.value) return parseInt(input.value, 10);
      return variants.length ? variants[0].id : null;
    }

    function currentQty() {
      var f = mainForm();
      if (!f) return 1;
      var q = assocQuery(f, '[name="quantity"]');
      var n = q ? parseInt(q.value, 10) : 1;
      return n > 0 ? n : 1;
    }

    function findVariant(id) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === id) return variants[i];
      }
      return null;
    }

    /* ---------- price sync ---------- */
    var priceEl = bar.querySelector("[data-bu-price]");
    var mrpEl = bar.querySelector("[data-bu-mrp]");
    var offEl = bar.querySelector("[data-bu-off]");
    var atcBtn = bar.querySelector("[data-bu-atc]");
    var buyBtn = bar.querySelector("[data-bu-buy]");
    var toast = bar.querySelector("[data-bu-toast]");

    /* v12: write money text AND clear converter apps' cached-original
       attributes so they re-detect + re-convert the fresh INR amount */
    function setMoneyText(el, txt) {
      if (!el) return;
      el.textContent = txt;
      for (var i = el.attributes.length - 1; i >= 0; i--) {
        var n = el.attributes[i].name;
        if (n.indexOf("data-") === 0 && (n.indexOf("price") > -1 || n.indexOf("currency") > -1 || n.indexOf("bucks") > -1 || n.indexOf("mlveda") > -1 || n.indexOf("original") > -1)) {
          el.removeAttribute(n);
        }
      }
    }

    var lastId = null;
    function sync() {
      var id = currentVariantId();
      if (id === lastId) return;
      lastId = id;
      var v = findVariant(id);
      if (!v) return;

      setMoneyText(priceEl, v.price);
      if (mrpEl) {
        if (v.mrp) { setMoneyText(mrpEl, v.mrp); mrpEl.hidden = false; }
        else { mrpEl.hidden = true; }
      }
      if (offEl) {
        if (v.off) { offEl.textContent = v.off + "% Off"; offEl.hidden = false; }
        else { offEl.hidden = true; }
      }

      var soldOut = v.available === false;
      if (atcBtn) {
        atcBtn.disabled = soldOut;
        var lbl = atcBtn.querySelector(".bu-sticky-btn__label");
        if (lbl) lbl.textContent = soldOut ? "Sold Out" : "Add To Cart";
      }
      if (buyBtn) buyBtn.disabled = soldOut;
    }
    document.addEventListener("change", function (e) {
      if (e.target && e.target.name === "id") setTimeout(sync, 50);
    }, true);
    setInterval(sync, 800);
    sync();

    /* ---------- helpers ---------- */
    function showToast(msg) {
      if (!toast) { alert(msg); return; }
      toast.textContent = msg;
      toast.hidden = false;
      clearTimeout(showToast._t);
      showToast._t = setTimeout(function () { toast.hidden = true; }, 2500);
    }

    function scrollToVariantPicker() {
      var picker = document.querySelector('.hdt-main-product-wrap [data-type="_product-variant-picker"], .hdt-main-product-wrap variant-selects, .hdt-main-product-wrap hdt-variant-picker, .hdt-main-product-wrap [class*="variant-picker"]');
      if (picker) picker.scrollIntoView({ behavior: "smooth", block: "center" });
    }

    function setLoading(btn, on) {
      if (btn) btn.classList.toggle("is-loading", on);
    }

    function ajaxAdd(done, fail) {
      var id = currentVariantId();
      if (!id) { if (fail) fail(); return; }
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: id, quantity: currentQty() })
      }).then(function (r) {
        if (!r.ok) throw new Error("add failed");
        return r.json();
      }).then(function () { done(); }).catch(function () { if (fail) fail(); });
    }

    function openCartDrawer() {
      /* v11: prefer the theme's own trigger so the drawer component's
         internal open state stays in sync and its close button works. */
      var trigger = document.querySelector('[aria-controls="CartDrawer"]');
      if (trigger) { trigger.click(); return true; }
      var d = document.querySelector("#CartDrawer");
      if (d && typeof d.showModal === "function" && !d.open) {
        try { d.showModal(); return true; } catch (e) { /* noop */ }
      }
      return false;
    }

    /* ---------- Add To Cart: instant drawer + double-tap guard ---------- */
    var lastAtcAt = 0;
    function handleAtc() {
      if (atcBtn && atcBtn.disabled) return;
      var now = Date.now();
      if (now - lastAtcAt < 600) return;
      lastAtcAt = now;

      var form = mainForm();
      var themeBtn = form ? assocQuery(form, 'button[name="add"]') : null;

      if (themeBtn && themeBtn.disabled) {
        showToast("Please select a size first");
        scrollToVariantPicker();
        return;
      }

      openCartDrawer();

      if (form && themeBtn) {
        try {
          form.requestSubmit(themeBtn);
        } catch (e) {
          themeBtn.click();
        }
        return;
      }

      setLoading(atcBtn, true);
      ajaxAdd(function () {
        setLoading(atcBtn, false);
      }, function () {
        setLoading(atcBtn, false);
        showToast("Could not add to cart. Please try again.");
      });
    }

    /* ---------- Buy Now ---------- */
    function gokwikBuyNowBtn() {
      var b = document.getElementById("gokwik-buy-now");
      if (b && !b.disabled) return b;
      return null;
    }

    function handleBuy() {
      if (buyBtn && (buyBtn.disabled || buyBtn.classList.contains("is-loading"))) return;

      var form = mainForm();
      var themeBtn = form ? assocQuery(form, 'button[name="add"]') : null;
      if (themeBtn && themeBtn.disabled) {
        showToast("Please select a size first");
        scrollToVariantPicker();
        return;
      }

      var gk = gokwikBuyNowBtn();
      if (gk) { gk.click(); return; }

      setLoading(buyBtn, true);
      ajaxAdd(function () {
        setLoading(buyBtn, false);
        var intl = document.documentElement.classList.contains("bu-market-intl");
        var gkDrawerBtn = document.querySelector(".gokwik-checkout button");
        if (!intl && gkDrawerBtn) {
          document.documentElement.style.removeProperty("overflow");
          document.body.style.removeProperty("overflow");
          setTimeout(function () { gkDrawerBtn.click(); }, 300);
        } else {
          window.location.href = "/checkout";
        }
      }, function () {
        setLoading(buyBtn, false);
        showToast("Could not add to cart. Please try again.");
      });
    }

    /* ---------- delegated clicks ---------- */
    document.addEventListener("click", function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest("[data-bu-atc]")) { e.preventDefault(); handleAtc(); }
      else if (t.closest("[data-bu-buy]")) { e.preventDefault(); handleBuy(); }
    });
  });
})();
